import React, { Dispatch, SetStateAction, useContext, useState } from "react";
import { Button, Form, Modal, Row } from "react-bootstrap";
import ColM from "../../assets/components/column/ColM";
import Icon from "../../assets/components/icon";
import messageBox from "../../assets/components/message/MessageBox";
import { baseUrl } from "../../config/serverConfig";
import useAxios from "../../hooks/axios/useAxios";
import { DefaultResponseType } from "../../types/axiosTypes";
import { Order } from "../../types/orderTypes";
import { EmailAuthProvider, reauthenticateWithCredential } from "firebase/auth";
import AuthProvider from "../../context/auth/";
import InputField from "../forms/Field";
import { Submission } from "../../types/authTypes";

const ConfirmOrderModal = ({
  order,
  setRefresh,
  refresh,
}: {
  order: Order;
  refresh: boolean;
  setRefresh: Dispatch<SetStateAction<boolean>>;
}) => {
  const { user } = useContext(AuthProvider);
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  // Bevestigen stuurt de order naar productie én verstuurt drie mails. Twee
  // keer klikken mag dus niet: de knop blijft geblokkeerd tot het verzoek
  // klaar is, en de modal gaat intussen niet dicht.
  const [bezig, setBezig] = useState(false);
  const handleClose = () => {
    if (bezig) return;
    setShow(false);
  };
  const handleShow = () => setShow(true);

  console.log(order.id);

  const { fetchData } = useAxios({
    method: "post",
    body: { id: order.id },
  });

  const promoteOrder = async (event: Submission) => {
    event.preventDefault();

    if (password === "") {
      return messageBox({
        message: "Voer wachtwoord in",
        type: "error",
      });
    }

    if (bezig) return;
    setBezig(true);

    const credential = EmailAuthProvider.credential(user!.email!, password);

    reauthenticateWithCredential(user!, credential)
      .then(async function (a: any) {
        // User re-authenticated.
        const response: DefaultResponseType<Order> = await fetchData(
          `${baseUrl}/order/promote-order`
        );

        if (response.error) {
          setBezig(false);
          messageBox({
            message: "Fout tijdens het wijzigen van order",
            type: "error",
          });
        } else {
          setShow(false);
          messageBox({
            message:
              "Na het definitief maken van uw order kunt u geen wijzigingen meer zelf toevoegen. Neem contact op met Stair Solutions.",
            type: "success",
          });
          setRefresh(!refresh);
          setBezig(false);
        }
        console.log(a);
      })
      .catch(function (error) {
        // An error happened.
        setBezig(false);
        messageBox({
          message: "Onjuiste wachtwoord",
          type: "error",
        });
        console.log(error);
      });
  };

  return (
    <>
      <Button onClick={handleShow} variant="success" size="sm">
        Order bevestigen
      </Button>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        centered
        size="xl"
        fullscreen="xl-down"
        contentClassName="modal-background p-0"
      >
        <Modal.Body className="modal-background w-100 mh-100 ">
          <Row>
            <ColM xs={12}>
              <div className="d-flex justify-content-between align-items-center h-100">
                <h3 style={{ fontWeight: 200, marginBottom: 0 }}>
                  Order bevestigen
                </h3>
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    padding: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                  className="bg-secondary rounded-circle"
                  onClick={handleClose}
                >
                  <Icon
                    icon="close"
                    style={{ width: "10px", height: "10px" }}
                  />
                </div>
              </div>
            </ColM>

            <ColM xs={12}>
              <Row>
                <div
                  className="mb-3 p-3"
                  style={{
                    backgroundColor: "rgba(255, 193, 7, 0.12)",
                    border: "1px solid rgba(255, 193, 7, 0.5)",
                    borderRadius: 6,
                  }}
                >
                  Na het definitief maken van uw order kunt u geen wijzigingen
                  meer zelf toevoegen. Neem contact op met Stair Solutions.
                </div>

                <div className="d-flex justify-content-center mb-2">
                  Voer de wachtwoord waarmee je inlogt ter bevestiging in.
                  Hiermee bevestig je de order naar Stair Solutions.
                </div>

                <Form onSubmit={promoteOrder}>
                  <InputField
                    label="Wachtwoord"
                    parse={String}
                    value={password}
                    set={setPassword}
                    sizes={{ xs: 12 }}
                    type="password"
                  />
                  <div className="d-flex justify-content-end gap-2">
                    <Button
                      size="sm"
                      variant="secondary"
                      type="button"
                      disabled={bezig}
                      onClick={handleClose}
                    >
                      Annuleren
                    </Button>
                    <Button
                      size="sm"
                      variant="success"
                      type="submit"
                      disabled={bezig}
                    >
                      {bezig ? "Bezig met bevestigen…" : "Bevestigen"}
                    </Button>
                  </div>
                </Form>
              </Row>
            </ColM>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ConfirmOrderModal;
